export const LOCATION_STORE_PARAM_NAME = '_ls_';

// Carries the name of the selection being edited into the checkout page, so the
// "add to list" action updates that selection instead of creating a new one.
export const EDIT_SELECTION_PARAM = 'editSelection';
